<!--
  This dialog will be used to fill the client's response for gourmet popup.
-->
<template>
  <dialog-form
    class="gourmet-popup-dialog"
    :show-dialog="isShowDialog"
    :is-required="true"
    @open="dialogOpen"
    @cancel="hideDialog"
    @submit="submitForm"
  >
    <template #title>
      Tell the User about GoGo's Gourmet Service!
    </template>

    <div class="row align-items-center">
      <div class="col-sm-12">
        It looks like this client is going to or coming from a restaurant, please ask them if they'd be interested in more information about
        GoGo's Gourmet service. We can follow up with an email or phone call with more information.
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <label class="control-label"> Client's Response* </label>
        <dropdown-list
          v-model="gourmetPopupResponse.clientResponse"
          placeholder="Please choose client's response"
          required
          :options="clientResponseList"
        />
      </div>
    </div>

    <template v-if="isNotInterested">
      <div class="row">
        <div class="col-12">
          <label class="control-label"> Reason* </label>
          <dropdown-list
            v-model="gourmetPopupResponse.notInterestedReason"
            required
            :options="notInterestedReasonList"
          />
        </div>
      </div>

      <div
        v-if="isNotInterestedOtherReason"
        class="row"
      >
        <div class="col-12">
          <label class="control-label"> Other Reason* </label>
          <sanitized-textarea
            v-model="gourmetPopupResponse.otherReason"
            required
          />
        </div>
      </div>
    </template>
  </dialog-form>
</template>

<script lang="ts">
import { ref, Ref, computed } from 'vue';

import util from '@/Utils/util';

const dialogId = 'gourmet-popup-dialog';

const clientResponseList = [
  { id: 1, key: 'Interested to learn more', label: 'Interested to learn more' },
  { id: 2, key: 'Not interested', label: 'Not interested' },
];
const notInterestedReasonList = [
  { id: 1, key: 'No Reason', label: 'No Reason' },
  { id: 2, key: 'Already know about it', label: 'Already know about it' },
  { id: 3, key: 'Prefers going to restaurants on their own', label: 'Prefers going to restaurants on their own' },
  { id: 4, key: 'Prefers ordering from restaurants themselves', label: 'Prefers ordering from restaurants themselves' },
  { id: 5, key: "Thinks it's too expensive", label: "Thinks it's too expensive" },
  { id: 6, key: 'Other Reason', label: 'Other Reason' },
];

export default {
  name: 'GourmetPopupDialog',

  props: {
    isShowDialog: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['submit', 'cancel'],

  setup: (props: any, context: any) => {
    const { emit } = context;

    const gourmetPopupResponse: Ref<any> = ref({
      clientResponse: 'Interested to learn more',
      notInterestedReason: '',
      otherReason: '',
    });

    const isNotInterested = computed(() => {
      return gourmetPopupResponse.value.clientResponse === clientResponseList[1].key;
    });

    const isNotInterestedOtherReason = computed(() => {
      return gourmetPopupResponse.value.notInterestedReason === notInterestedReasonList[5].key;
    });

    const dialogOpen = () => {
      gourmetPopupResponse.value.clientResponse = 'Interested to learn more';
      gourmetPopupResponse.value.notInterestedReason = '';
      gourmetPopupResponse.value.otherReason = '';
    };

    const submitForm = () => {
      let notInterestedReason;
      if (isNotInterested.value && isNotInterestedOtherReason.value) {
        notInterestedReason = gourmetPopupResponse.value.otherReason;
      } else if (isNotInterested.value) {
        notInterestedReason = gourmetPopupResponse.value.notInterestedReason;
      }

      const postData: any = {
        clientResponse: gourmetPopupResponse.value.clientResponse,
        notInterestedReason,
      };

      emit('submit', postData);
    };

    const hideDialog = () => {
      emit('cancel');
    };

    return {
      dialogId,
      clientResponseList,
      notInterestedReasonList,
      isNotInterested,
      isNotInterestedOtherReason,
      gourmetPopupResponse,

      util,

      dialogOpen,
      submitForm,
      hideDialog,
    };
  },
};
</script>

<style lang="scss">
.gourmet-popup-dialog {
  &.el-dialog {
    min-width: 700px !important;
  }
  .control-label {
    color: #252422 !important;
    font-weight: 500 !important;
  }
}
</style>
